import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./index.css";
import "./assets/css/app.min.css";
import DiscountAll from "./Components/Modals/DiscountAll.js";
import CustomRoutes from "./CustomRoutes";
import Toaster from "./screen-share/components/Toaster.tsx";
import Join from "./screen-share/components/join/Join.tsx";
import { callRefreshService, logoutService } from "./services/auth.service.js";
import { setApiKey } from "./crmSettingsAdapter.js";
import { setAuthHeader } from "./services/http-client.js";
import { const_var } from "./redux/reducers/reducer.js";
import StateChange from "./Components/StateChange/StateChange.js";
import { getSelectedTabstate, setZipCodeVal } from "./action/index.js";
import { setDefaultValuesOnSalesLoginBtnClick } from "./redux/reducers/utils.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
let DomainURI = window.location.pathname.includes("manufacturer_active_discount");
let url = window.location.href;
let isRedirect = false;
export const renderApp = () => {
	if (isRedirect) {
		root.render(<Provider store={store}>{const_var.showLoginScreen ? <StateChange /> : <CustomRoutes />}</Provider>);
		return;
	}
	if ((url.includes("pre.senseicrm") || url.includes("crm.senseicrm")) && window.location.pathname.includes("join")) {
		root.render(
			<Provider store={store}>
				<Toaster />
				<Join />
			</Provider>
		);
	} else if (DomainURI !== undefined && DomainURI == true) {
		root.render(
			<Provider store={store}>
				<DiscountAll />
			</Provider>
		);
	} else {
		root.render(
			<Provider store={store}>
				<CustomRoutes />
			</Provider>
		);
	}
};

const initApp = async () => {
	const redirectToLogin = () => {
		store.dispatch(setZipCodeVal("", "statemanufacturechangepage"));
		setDefaultValuesOnSalesLoginBtnClick();
		store.dispatch(getSelectedTabstate("loginstyletab"));
		const_var.showLoginScreen = true;
	};
	try {
		const res = await callRefreshService();
		const authToken = res?.auth_data?.access_token;
		if (!authToken) {
			return redirectToLogin();
		}
		//setToken(authToken);
		setAuthHeader(authToken);
	} catch (error) {
		isRedirect = true;
		setApiKey();
		const temp = const_var.crmSetting.is_Edit;
		store.dispatch(getSelectedTabstate("statechange"));
		const_var.crmSetting.is_Edit = temp;
		localStorage.clear();
		// redirectToLogin();
		console.error("Error refreshing token", error.message);
	} finally {
		renderApp();
	}
};
initApp();
